import { Space } from 'antd';
import { PropsWithChildren } from 'react';
import { createPortal } from 'react-dom';

export const appBarActionsId = 'appBarActions';
export const AppBarActionsPortal = ({
  children,
}: PropsWithChildren): JSX.Element | null => {
  const appBarActionsContainer = document.getElementById(appBarActionsId);
  return appBarActionsContainer
    ? createPortal(<Space>{children}</Space>, appBarActionsContainer)
    : null;
};

export const appBarVersionNumId = 'appBarVersionNum';
export const AppBarVersionPortal = ({
  children,
}: PropsWithChildren): JSX.Element | null => {
  const appBarVersionContainer = document.getElementById(appBarVersionNumId);
  return appBarVersionContainer
    ? createPortal(children, appBarVersionContainer)
    : null;
};
